var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDosingFillingPumpOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ON",
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 70,
    viewBox: "0 0 50 70",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9870",
    "data-name": "Group 9870"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3898",
    "data-name": "Path 3898",
    d: "M2.72,40.256,0,37.5l2.16-2.19a6.975,6.975,0,0,1,4.99-2.1H32.41V0h3.85V37.115H7.15a3.185,3.185,0,0,0-2.27.95Z",
    fill: "#e9cc63"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_9883",
    "data-name": "Group 9883",
    transform: "translate(17.39 23.703)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9873",
    "data-name": "Group 9873",
    transform: "translate(12.55)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9871",
    "data-name": "Group 9871",
    transform: "translate(0.32 0.33)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4310",
    "data-name": "Rectangle 4310",
    width: 8.59,
    height: 7.501,
    fill: "#e9cc63"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9872",
    "data-name": "Group 9872"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3899",
    "data-name": "Path 3899",
    d: "M38.53,24.35V31.2H30.58V24.35h7.95m.64-.65H29.94v8.151h9.23V23.7Z",
    transform: "translate(-29.94 -23.7)",
    fill: "#404041"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9876",
    "data-name": "Group 9876",
    transform: "translate(0 8.331)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9874",
    "data-name": "Group 9874",
    transform: "translate(0.32 0.33)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4311",
    "data-name": "Rectangle 4311",
    width: 5.52,
    height: 5.601,
    fill: "#e9cc63"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9875",
    "data-name": "Group 9875"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3900",
    "data-name": "Path 3900",
    d: "M22.91,32.68v4.951H18.03V32.68h4.88m.64-.65H17.39v6.251h6.16V32.03Z",
    transform: "translate(-17.39 -32.03)",
    fill: "#404041"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9879",
    "data-name": "Group 9879",
    transform: "translate(5.4 7.381)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9877",
    "data-name": "Group 9877",
    transform: "translate(0.32 0.33)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4312",
    "data-name": "Rectangle 4312",
    width: 22.89,
    height: 8.511,
    fill: "#e9cc63"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9878",
    "data-name": "Group 9878"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3901",
    "data-name": "Path 3901",
    d: "M45.68,31.73v7.861H23.43V31.73H45.68m.64-.65H22.79v9.161H46.32V31.08Z",
    transform: "translate(-22.79 -31.08)",
    fill: "#404041"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9882",
    "data-name": "Group 9882",
    transform: "translate(1.73 15.242)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9880",
    "data-name": "Group 9880",
    transform: "translate(0.31 0.33)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3902",
    "data-name": "Path 3902",
    d: "M25.44,69.674a4.986,4.986,0,0,1-4.94-5.011V44.731H19.43V39.27H49.67v5.461H48.6V64.664a4.979,4.979,0,0,1-4.94,5.011H25.44Z",
    transform: "translate(-19.43 -39.27)",
    fill: "#e9cc63"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9881",
    "data-name": "Group 9881"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3903",
    "data-name": "Path 3903",
    d: "M49.36,39.59V44.4H48.29V64.664a4.648,4.648,0,0,1-4.62,4.681H25.44a4.655,4.655,0,0,1-4.62-4.681V44.411H19.75V39.6H49.36m.64-.66H19.12v6.111h1.07V64.664a5.3,5.3,0,0,0,5.26,5.331H43.68a5.3,5.3,0,0,0,5.26-5.331v-19.6H50V38.94Z",
    transform: "translate(-19.12 -38.94)",
    fill: "#404041"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDosingFillingPumpOn);
export default __webpack_public_path__ + "static/media/dosing_filling_pump_on.18f7b14927c2f545b2b30323a979fdfa.svg";
export { ForwardRef as ReactComponent };